'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/throttleTime';
const angular = require('angular');
const {extend, isFunction} = angular;

module.exports = [
  '$provide',
  FirebaseObjectDecorator];

function FirebaseObjectDecorator(
  $provide,
) {
  $provide.decorator('FirebaseObjectFactory', [
    '$delegate',
    decorateService]);

  function decorateService(
    $delegate,
  ) {
    $delegate.prototype.$toObservable = firebaseObjectToObservable;

    /**
     *
     * @param {Object} [config]
     * @param {boolean} [config.onValue=true] -
     * @param {boolean} [config.onChildAdded=false] -
     * @param {boolean} [config.onChildChanged=false] -
     * @param {boolean} [config.onChildRemoved=false] -
     * @param {number}  [config.throttle=1000] - If 0, no throttling is used. Must be non-negative.
     * @param {boolean} [config.emitElement=false] -
     * @param {boolean} [config.destroySource=false] -
     * @param {boolean} [config.loadItems=false] - select->switchLatest delaying for $loaded on each item in the list
     * @returns {Rx.Observable}
     */
    function firebaseObjectToObservable(config) {
      config = extend({
        onValue: true, // not compatible with emitElement
        onChildAdded: false,
        onChildChanged: false,
        onChildRemoved: false,
        throttle: 1000,
        emitElement: false, // not compatible with onValue
        destroySource: false,
        loadItems: false
      }, config || {});

      var self = this;
      var observable = Observable.create(
        function (observer) {
          var callback;
          var unwatchChange;
          var offCalled = false;
          if (config.emitElement) {
            callback = observer.next.bind(observer);
          } else {
            callback = observer.next.bind(observer, self);
          }

          if (config.onValue) {
            var unwatchValue = self.$on('value', callback);
          }

          if (config.onChildAdded) {
            var unwatchAdd = self.$on('child_added', callback);
          }

          if (config.onChildChanged) {
            unwatchChange = self.$on('child_changed', callback);
          } else { // TODO(FBO): remove the else statement when events are working as expected
            self.$loaded().then(function () { // bind to the changed event after at least some of the data has been loaded already
              // Avoid race condition
              if (!offCalled)
                unwatchChange = self.$on('child_changed', callback);
            });
          }

          if (config.onChildRemoved) {
            var unwatchRemove = self.$on('child_removed', callback, null);
          }

          return function () {
            offCalled = true;
            if (self && isFunction(self.$off)) {
              unwatchValue && self.$off('value', unwatchValue);
              unwatchAdd && self.$off('child_added', unwatchAdd);
              unwatchChange && self.$off('child_changed', unwatchChange);
              unwatchRemove && self.$off('child_removed', unwatchRemove);
            }

            if (config.destroySource && self && isFunction(self.$destroy)) {
              self.$destroy();
            }
          }
        }).share();

      if (!config.emitElement) {
        observable = observable.startWith(self);
      }

      if (config.throttle) {
        if (config.emitElement) {
          observable = observable
            .buffer(observable.throttleTime(config.throttle))
            .map(function (buffer) {
              var length = buffer.length;
              if (length) {
                //console.debug('FirebaseObject.toObservable updating on buffered event.', buffer[buffer.length - 1]);
                return buffer[length - 1];
              } else {
                //console.debug('FirebaseObject.toObservable updating on buffered event.', buffer);
                return null;
              }
            })
        } else {
          observable = observable
            .sampleTime(config.throttle)
            .map(function () {
              //console.debug('FirebaseObject.toObservable updating on buffered event. size=', self.$size());
              return self;
            })
        }
      }

      if (config.loadItems) {
        observable = observable
          .switchMap(loadItems)
      }

      return observable;
    }

    return $delegate;

    function loadItems(list) {
      var promises = {};
      for (var key in list) {
        if (list.hasOwnProperty(key) && list[key] && isFunction(list[key].$loaded)) {
          promises[key] = list[key].$loaded().catch(onErrorNull);
        }
      }
      return Promise.props(promises).then(function () {
        return list;
      })
    }

    function onErrorNull(e) {
      return null
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/angular-rx-attrs/FirebaseObjectToObservable.js